<template>
  <ContentWrap>
    <el-alert
      type="info"
      :closable="false"
      class="mb-16px"
      :title="`欢迎，${merchantName || '商家'}。已开通模块：${moduleLabels}`"
    />
    <el-row :gutter="16">
      <el-col v-for="m in modules" :key="m.moduleId" :span="8">
        <el-card shadow="hover" class="module-card" @click="goModule(m)">
          <h3>{{ m.moduleTitle }}</h3>
          <p class="text-secondary text-13px">主体 ID：{{ m.subjectId }}</p>
          <el-button type="primary" link>进入</el-button>
        </el-card>
      </el-col>
    </el-row>
    <el-empty
      v-if="modules.length === 0"
      description="尚未开通经营模块，请在对应业务移动端提交入驻申请"
    />
  </ContentWrap>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { getWorkbenchContext, type ModuleEntitlement } from '@/api/merchant/workbench'
import { filterMenuByPermissions, getModule, type ModuleId } from '@/views/merchant/registry/modules'
import { getMerchantSession, setMerchantSession } from '@/views/merchant/registry/merchant-session'
import { ContentWrap } from '@/components/ContentWrap'

defineOptions({ name: 'MerchantWorkbench' })

const router = useRouter()
const merchantName = ref('')
const modules = ref<ModuleEntitlement[]>([])

const moduleLabels = computed(() => modules.value.map((m) => m.moduleTitle).join('、') || '无')

const goModule = (m: ModuleEntitlement) => {
  const desc = getModule(m.moduleId)
  if (!desc) return
  const perms = new Set(getMerchantSession()?.permissions || [])
  const allowed = filterMenuByPermissions(desc.menu, perms, m.moduleId as ModuleId)
  if (allowed.length === 0) {
    ElMessage.warning('当前账号暂无该模块可用菜单')
    return
  }
  // 优先进入模块首页；无首页权限则落到第一个有权菜单
  const home = allowed.find((item) => item.path === desc.homePath)
  router.push(home?.path || allowed[0].path)
}

onMounted(async () => {
  const ctx = await getWorkbenchContext()
  merchantName.value = ctx.shopName || ctx.merchantName || ''
  modules.value = ctx.modules || []
  // 刷新权限会话，保证侧栏与「进入」一致
  const sess = getMerchantSession()
  if (sess) {
    setMerchantSession({
      ...sess,
      merchantName: ctx.shopName || ctx.merchantName || sess.merchantName,
      shopName: ctx.shopName || sess.shopName,
      modules: ctx.modules || sess.modules,
      permissions: ctx.permissions || [],
      mallBizMode: ctx.mallBizMode || undefined
    })
  }
})
</script>

<style scoped>
.module-card {
  cursor: pointer;
  margin-bottom: 12px;
}
</style>
